import { INVOICE_PDF_QUERY, INVOICE_XML_QUERY } from './invoicing.gql';

import type { Invoice } from './types';

import { apolloClient } from '@/shared/api/apolloClient';

interface InvoiceContentResponse {
  invoiceXml?: { content: string; content_type: string };
  invoicePdf?: { content: string; content_type: string };
}

function triggerDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

function fileBase(invoice: Invoice): string {
  const folio = invoice.folio_number ?? invoice.id.slice(0, 8);
  const uuid_short = invoice.uuid ? invoice.uuid.slice(0, 8) : 'sin-uuid';
  return `cfdi-${folio}-${uuid_short}`;
}

export async function downloadXml(invoice: Invoice): Promise<void> {
  const result = await apolloClient.query<InvoiceContentResponse>({
    query: INVOICE_XML_QUERY,
    variables: { invoice_id: invoice.id },
    fetchPolicy: 'network-only',
  });
  const xml = result.data.invoiceXml?.content ?? '';
  const blob = new Blob([xml], { type: 'application/xml' });
  triggerDownload(blob, `${fileBase(invoice)}.xml`);
}

export async function downloadBase64Pdf(invoice: Invoice): Promise<void> {
  const result = await apolloClient.query<InvoiceContentResponse>({
    query: INVOICE_PDF_QUERY,
    variables: { invoice_id: invoice.id },
    fetchPolicy: 'network-only',
  });
  const b64 = result.data.invoicePdf?.content ?? '';
  const bytes = Uint8Array.from(atob(b64), (c) => c.charCodeAt(0));
  const blob = new Blob([bytes], { type: 'application/pdf' });
  triggerDownload(blob, `${fileBase(invoice)}.pdf`);
}
